import {
  Circle as CircleIcon,
  Film,
  Image as ImageIcon,
  LucideIcon,
  Music,
  Shapes,
  Sparkles,
  Square,
  Type,
  Wand2
} from 'lucide-react';
import { TrackKind } from '../../timeline/types';

// Strict set of fabric object types the editor creates and has settings panels for.
export const FABRIC_TYPE = {
  iText: 'i-text',
  textbox: 'textbox',
  image: 'image',
  rect: 'rect',
  circle: 'circle'
} as const;

export type FabricType = (typeof FABRIC_TYPE)[keyof typeof FABRIC_TYPE];

type ObjectMeta = {
  kind: TrackKind;
  label: string;
  icon: LucideIcon;
};

// Permissive: includes 'text' (legacy canvas JSON) and 'video' (pseudo-type derived from obj.videoSrc).
const FABRIC_TYPE_META: Record<string, ObjectMeta> = {
  [FABRIC_TYPE.iText]: { kind: 'text', label: 'Texto', icon: Type },
  [FABRIC_TYPE.textbox]: { kind: 'text', label: 'Texto', icon: Type },
  text: { kind: 'text', label: 'Texto', icon: Type },
  [FABRIC_TYPE.image]: { kind: 'media', label: 'Imagen', icon: ImageIcon },
  video: { kind: 'video', label: 'Video', icon: Film },
  [FABRIC_TYPE.rect]: { kind: 'shape', label: 'Rectángulo', icon: Square },
  [FABRIC_TYPE.circle]: { kind: 'shape', label: 'Círculo', icon: CircleIcon }
};

const DEFAULT_META: ObjectMeta = { kind: 'shape', label: 'Objeto', icon: Shapes };

export const getFabricTypeMeta = (type: string | undefined): ObjectMeta => FABRIC_TYPE_META[type ?? ''] ?? DEFAULT_META;

export const KIND_ICONS: Record<TrackKind, LucideIcon> = {
  text: Type,
  subtitle: Sparkles,
  media: ImageIcon,
  video: Film,
  audio: Music,
  shape: Square,
  effect: Wand2
};
